import { DashboardNav } from "@/components/dashboard/DashboardNav";
import { Outlet } from "react-router-dom";
import { TopBar } from "@/components/layouts/TopBar";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sheet, SheetContent } from "@/components/ui/sheet";

const DashboardLayout = () => {
  const isMobile = useIsMobile();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = localStorage.getItem("sidebar-collapsed");
    return savedState ? JSON.parse(savedState) : false;
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("sidebar-collapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Close mobile menu when screen size changes to desktop
  useEffect(() => {
    if (!isMobile) {
      setIsMobileMenuOpen(false);
    }
  }, [isMobile]);

  const handleSidebarToggle = () => {
    if (isMobile) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Desktop Sidebar */}
      {!isMobile && (
        <DashboardNav 
          collapsed={isSidebarCollapsed} 
          onToggle={handleSidebarToggle} 
        />
      )}
      
      {/* Mobile Sheet/Drawer */}
      {isMobile && (
        <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
          <SheetContent side="left" className="w-64 p-0 bg-card dark:bg-zinc-800 [&>button]:hidden">
            <DashboardNav 
              collapsed={false} 
              onToggle={handleMobileMenuClose}
              isMobile={true}
            />
          </SheetContent>
        </Sheet>
      )}
      
      {/* Main Content Area */}
      <div className={cn(
        "flex flex-col flex-1 transition-all duration-300 ease-in-out",
        // Desktop margins
        !isMobile && (isSidebarCollapsed ? "ml-20" : "ml-64"),
        // Mobile: full width
        isMobile && "ml-0"
      )}>
        <TopBar onMobileMenuToggle={handleSidebarToggle} />
        <main className="flex-1 overflow-y-auto p-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
